function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 25 22" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1 16c1.667-2.667 2.667-4 3-4 .5 0 4.5 4.5 5 5s2.5-10 3-10 3.5 14 4 14 4.5-19.5 5-19.5c.333 0 1.333 2.5 3 7.5" stroke="currentColor" strokeWidth="2" fill="none" fillRule="evenodd" /></svg>;
});